<div class="font wrapper">
  <div class="top-bar">
    <div class="content-start"></div>
    <div class="logo-div">
      <img
        src="assets/images/ecolab-logo-white-app-header.png"
        alt="EcoLab Logo"
        class="logo"
      />
    </div>
    <div class="content-end">
      <select
        [value]="currentLanguage"
        (change)="languageChange($event)"
        class="select-dropdown"
      >
        <option
          *ngFor="let option of languageOptions"
          [value]="option?.value"
          [selected]="option.value === currentLanguage"
        >
          {{ option.value }}
        </option>
      </select>
    </div>
  </div>
  <div class="status_request">
    <div class="bg-zinc-100">
      <div
        *ngIf="currentLanguage == 'English'"
        class="max-w-xl mx-auto px-4 pt-4 pb-2"
      >
        <h1 class="font mt-0" *ngIf="request == 'open'">Request Status</h1>
        <h1 class="font mt-0" *ngIf="request == 'close'">Request Closed</h1>
        <div class="flex justify-between gap-4">
          <p class="text-black text-[15px] font-bold leading-snug">Request</p>
          <a class="font-bold">View Details</a>
        </div>
      </div>
      <div
        *ngIf="currentLanguage == 'Spanish'"
        class="max-w-xl mx-auto px-4 pt-4 pb-2"
      >
        <h1 class="font mt-0" *ngIf="request == 'open'">
          Estado de la Solicitud
        </h1>
        <h1 class="font mt-0" *ngIf="request == 'close'">Solicitud Cerrada</h1>
        <div class="flex justify-between gap-4">
          <p class="text-black text-[15px] font-bold leading-snug">Solicitud</p>
          <a class="font-bold">Ver Detalles</a>
        </div>
      </div>
    </div>
  </div>
  <main class="font grow overflow-hidden">
    <div class="h-full relative">
      <div class="h-full min-h-0 overflow-scroll border-t border-white">
        <div class="max-w-xl mx-auto pt-4 px-4">
          <div>
            <div>
              <div class="mb-4">
                <div>
                  <strong>7/31/2024, 4:33 PM</strong>
                  <p class="font">{{ translations['issue_submitted'] }}</p>
                </div>
                <p class="font">
                  {{ translations['info_text'] }}
                  <a href="tel:+18003525326">1-800-35-CLEAN</a>
                </p>

                <div class="border-top pt-2">
                  <strong>10/31/2024, 5:33 PM</strong>
                  <p class="font">
                    Comment added. There is sound also coming in machine.
                  </p>
                </div>

                <div class="border-top pt-2">
                  <strong>11/31/2024, 6:20 PM</strong>
                  <p class="font">Moved from “Awaiting Review” to “Resolved”</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <div class="layout-bottom" *ngIf="request == 'open'">
    <div class="bg-zinc-100">
      <div class="max-w-xl mx-auto px-4 py-4">
        <div class="flex flex-row space-x-2">
          <button class="button-white-blue" routerLink="/close">
            {{ translations['close_request'] }}
          </button>
          <button
            class="button"
            data-bs-toggle="modal"
            data-bs-target="#addComment"
          >
            {{ translations['add_comment'] }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- The Modal -->
<div class="modal" id="addComment">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Modal body -->
      <div class="modal-body">
        <form>
          <div class="mb-3">
            <label for="email" class="form-label">Name:</label>
            <input type="email" class="form-control" />
          </div>
          <div class="mb-1">
            <label for="pwd" class="form-label">Comment:</label>
            <textarea rows="2" class="form-control"></textarea>
          </div>
        </form>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer pb-4">
        <div class="d-flex justify-content-between w-100">
          <button
            type="button"
            class="btn btn-light cancelButton"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary ms-2 w-100 sendButon"
            data-bs-dismiss="modal"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
